import { render, staticRenderFns } from "./dialog-content.vue?vue&type=template&id=d038446a"
import script from "./dialog-content.vue?vue&type=script&lang=js"
export * from "./dialog-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports